import React, { useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useSelector } from 'react-redux';
import { getSearchPatients } from '../../../network/appointment';
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from 'react-icons/io';
const CustomerAddition = ({ setDataSource, dataSource, t, form }) => {
  // const { companyName } = useSelector((state) => state.user);
  const [searchTxtAccount, setSearchTxtAccount] = useState('');
  const { currentLang } = useSelector((state) => state.user);
  const [count, setCount] = useState(dataSource.length);
  const columns = [
    {
      title: t.typeName,
      dataIndex: 'type_name',
      render: (text, record, index) => (
        <Input
          placeholder={t.typeName}
          style={{ width: '300px' }}
          value={record.type_name}
          disabled
        />
      ),
    },
    {
      title: t.typeCode,
      dataIndex: 'type_code',
      render: (text, record, index) => (
        <Input
          placeholder={t.typeCode}
          style={{ width: '300px' }}
          value={record.type_code}
          disabled
        />
      ),
    },
    {
      title: t.value,
      dataIndex: 'value',
      render: (text, record, index) => (
        <Input
          placeholder={t.values}
          style={{ width: '300px' }}
          value={record.value}
          type="number"
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              value: e.target.value,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    // {
    //   title: t.action,
    //   key: 'action',
    //   render: (text, record, index) => (
    //     <Space>
    //       <Popconfirm
    //         title={t.confirmDelete}
    //         onConfirm={() => handleDelete(record.key)}
    //       >
    //         <Button
    //           type="primary"
    //           danger
    //           icon={<DeleteOutlined />}
    //           size="small"
    //         />
    //       </Popconfirm>
    //     </Space>
    //   ),
    // },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
    };
    setDataSource((prevDataSource) => [...prevDataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        // pagination={{
        //   hideOnSinglePage: true,
        // }}
        pagination={{
          pageSize: 15,
          // current: pageCount,
          // total: totalPages,
          hideOnSinglePage: true,
          showSizeChanger: false,
          // align: 'center',
          itemRender: (current, type, originalElement) => {
            if (type === 'prev') {
              return (
                <div
                  // onClick={handlePrevClick}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    order: 1,
                  }}
                >
                  <IoIosArrowRoundForward
                    size={16}
                    style={{
                      transform:
                        currentLang === 'en'
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                    }}
                  />
                  <span>{t.prev}</span>
                </div>
              );
            }
            if (type === 'next') {
              return (
                <div
                  // onClick={handleNextClick}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    order: -1,
                  }}
                >
                  <span> {t.next}</span>
                  <IoIosArrowRoundBack
                    size={16}
                    style={{
                      transform:
                        currentLang === 'en'
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                    }}
                  />
                </div>
              );
            }
            return originalElement;
          },
          // onChange: (page) => {
          //   setFilterData({ ...filterData, page });
          // },
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      {/* <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button> */}
    </Card>
  );
};

export default CustomerAddition;
